import { isElementInViewport } from 'utils/view';
import debounce from 'lodash.debounce';

interface StatementCalloutProps {
    el: HTMLDivElement;
    props: {
        animatedText: string[];
    };
}

const DEBOUNCE_VALUE = 100;

// Escapes special HTML characters in the replacement text
function escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

// Run the functions on document ready
const StatementCallout = ({ el, props: { animatedText } }: StatementCalloutProps): void => {
    const textEl = el.querySelector('.statement-callout-text');

    if (!animatedText?.length || !textEl) {
        return;
    }

    // Iterate over each word and replace it with a span-wrapped version
    animatedText.forEach(word => {
        textEl.innerHTML = textEl.innerHTML.replace(
            escapeHtml(word),
            `<span class="statement-callout-highlight">${escapeHtml(word)}</span>`
        );
    });

    const highlightEls = el.querySelectorAll('.statement-callout-highlight');

    if (!highlightEls?.length) {
        return;
    }

    highlightEls.forEach((highlightEl, i) => {
        (highlightEl as HTMLSpanElement).style.transitionDelay = `${i * 0.6}s`;
    });

    const onScroll = (): void => {
        if (isElementInViewport(textEl)) {
            highlightEls.forEach(highlightEl => {
                (highlightEl as HTMLSpanElement).classList.add('is-active');
            });
        } else {
            highlightEls.forEach(highlightEl => {
                (highlightEl as HTMLSpanElement).classList.remove('is-active');
            });
        }
    };

    // wait for the page to load before checking if the element is in view
    setTimeout(onScroll, 2000);
    window.addEventListener('scroll', debounce(onScroll, DEBOUNCE_VALUE));
};

export default StatementCallout;
